import { useState, useRef, useEffect } from 'react';
import { FaSearch, FcSearch } from "react-icons/fa";
import { FaRectangleXmark } from "react-icons/fa6";
import { HiMiniXMark } from "react-icons/hi2";

// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// used to use Bootstrap elements
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu, Form, FormControl, FloatingLabel, FormLabel, Label, Stack, Row, Col, Container, Collapse, Button } from 'react-bootstrap';


    
//console.log(complexNames);

var filterOptions;

function SelectDropdown({ searchTerm, setSearchTerm, filteredOptions, setFilteredOptions, selectedBuildingRef }) {
    const dropdownRef = useRef(null);
    const containerRef = useRef(null);

    //const [searchTerm, setSearchTerm] = useState('');
    const [visible, setVisible] = useState(false);

    
    

    useEffect(() => {
        //if (visible)    dropdownRef.current.click();
        // add a mousedown event listener that triggers the handleClickOutside function
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // removes the event listener to prevent memory leaks from useEffect
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // [visible] event listener updates based on the visible variable
    }, [visible]);

    // used when the user clicks away from the search bar
    function handleClickOutside(event) {
        if (containerRef.current && !containerRef.current.contains(event.target)) setVisible(false);
    }
    // used when the user presses the enter key 
    function handleKeyDown(event) {
        if (event.key === "Enter") { 
            dropdownRef.current.click(); 
            event.preventDefault();
            
            // hides the menu options
            setVisible(false);
        } 
    }

    // used when the user types in the search bar
    function handleInput(event) {
        setSearchTerm(event.target.value);
        setVisible(true);
    }
    // used when the user clicks on the search bar
    function handleInput2() {
        // toggles hide/show
        setVisible(!visible);
    }
    // used when the user clicks on the search bar
    function handleInput4() {
        // toggles hide/show
        console.log(visible);
        setVisible(!visible);
        console.log(visible);
        if (!visible) {
            //console.log('why');
            document.getElementsByClassName('inputBar')[0].focus();
        } else {
            document.getElementsByClassName('inputBar')[0].blur();
        }
        
    }
    function handleInput3() {
        setSearchTerm('');
        selectedBuildingRef.current = null;
        setVisible(true);
        document.getElementsByClassName('inputBar')[0].focus();

        // Let the selected building stay flagged until after rebuild
  setTimeout(() => {
    selectedBuildingRef.current = null;
  }, 0);
    }

    const handleSelect = (selectedItem) => {
        console.log("Selected item:", selectedItem);
        selectedBuildingRef.current = selectedItem;
        setSearchTerm(selectedItem); // Update the input field with the selected item
        setVisible(false);  // Optionally, hide the dropdown menu
    };
    

    return (
        <>
           
           <Dropdown 
        //    className={"dropdownz"}
            style={{margin: "1%", width: "98%"}}
            ref={containerRef}
            //show={visible}
           >
              <FloatingLabel className='floating-label'>
                <b>Select a Building Complex Name:</b>
              </FloatingLabel>
              <Dropdown.Toggle as={'text'} id="dropdown-basic" ref={dropdownRef}>
                    <FormControl
                        id='dropdown-text' 
                        type='text'
                        placeholder="Click to see the list of complex names" 
                        className='inputBar'
                        value={searchTerm}
                        onKeyDown={handleKeyDown}
                        onChange={handleInput}
                        onClick={handleInput2}
                        aria-expanded={visible}
                        aria-controls='collapse-dropdown'
                        style={{
                            paddingRight: '0%', // covers a small percentage of the RHS of the text
                            whiteSpace: 'nowrap', // prevent text breaking into a new line
                            overflow: 'hidden', // overflow type is hidden
                            textOverflow: 'ellipsis' // ... effect for the overflow (dependent on overflow)
                        }}
                        >
                    </FormControl>
                    {searchTerm.length === 0 ? 
                        <FaSearch id='search-icon' onClick={handleInput4}></FaSearch>:
                        <HiMiniXMark id='search-icon' onClick={handleInput3}></HiMiniXMark>
                    }
              </Dropdown.Toggle>
              <Collapse in={visible}>
              {filteredOptions.length > 0 ? (
                <Dropdown.Menu style={{width: '100%'}}>
                    {filteredOptions.map((item) => (
                        <Dropdown.Item onClick={() => handleSelect(item)}>
                            {item}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
               ) : (
                <Dropdown.Menu style={{width: '100%'}}>
                    <Dropdown.Item disabled>No results found</Dropdown.Item>
                </Dropdown.Menu>
               )}
                {/* </div>   */}
               </Collapse>
            </Dropdown> 
            
        </>
        
    );
}
// export array variable for MapChart.jsx to change the opacity of the buildings that are not in the filtered list
// export function getFilterOptions() {
//     return complexNames.filter(option => 
//         option?.toLowerCase().includes(searchTerm?.toLowerCase())
//     ) || [];
// }

export default SelectDropdown;